'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dName$0024 from "./presto.types$-Credential-Name$.js";
var $p;
/** @constructor */
function $c_Lpresto_CredentialTables$$anon$16() {
}
export { $c_Lpresto_CredentialTables$$anon$16 as $c_Lpresto_CredentialTables$$anon$16 };
$p = $c_Lpresto_CredentialTables$$anon$16.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_CredentialTables$$anon$16;
/** @constructor */
function $h_Lpresto_CredentialTables$$anon$16() {
}
export { $h_Lpresto_CredentialTables$$anon$16 as $h_Lpresto_CredentialTables$$anon$16 };
$h_Lpresto_CredentialTables$$anon$16.prototype = $p;
$p.aL = (function(item) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lcom_raquo_laminar_api_Implicits__textToTextNode__O__Lcom_raquo_laminar_modifiers_RenderableText__Lcom_raquo_laminar_nodes_TextNode($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a, item.xi.fh, $j_presto$002etypes$0024$002dCredential$002dName$0024.$m_Lpresto_types$CredentialName$().adq());
});
var $d_Lpresto_CredentialTables$$anon$16 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_CredentialTables$$anon$16, "presto.CredentialTables$$anon$16", ({
  FA: 1,
  z: 1
}));
export { $d_Lpresto_CredentialTables$$anon$16 as $d_Lpresto_CredentialTables$$anon$16 };
//# sourceMappingURL=presto.-Credential-Tables$$anon$16.js.map
